import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  challenges: [],
  getChallengesLoading: false,
  getChallengesError: null,
  getChallengesSuccess: false,

  closedChallenges: [],
  getClosedChallengesLoading: false,
  getClosedChallengesError: null,
  getClosedChallengesSuccess: false,

  positions: [],
  getPositionsLoading: false,
  getPositionsError: null,
  getPositionsSuccess: false,

  getChallengeInfoLoading: false,
  getChallengeInfoError: null,
  getChallengeInfoSuccess: false,
  challengeInfo: null,
};

const ChallengeMainSlice = createSlice({
  name: "Challenge main",
  initialState,
  reducers: {
    getChallengesRequest: (state) => {
      state.getChallengesLoading = true;
      state.getChallengesError = null;
      state.getChallengesSuccess = false;
      state.challenges = [];
    },
    getChallengesSuccess: (state, { payload }) => {
      state.challenges = payload;
      state.getChallengesLoading = false;
      state.getChallengesError = null;
      state.getChallengesSuccess = true;
    },
    getChallengesError: (state, { payload }) => {
      state.getChallengesLoading = false;
      state.getChallengesError = payload;
      state.getChallengesSuccess = false;
    },

    getClosedChallengesRequest: (state) => {
      state.getClosedChallengesLoading = true;
      state.getClosedChallengesError = null;
      state.getClosedChallengesSuccess = false;
      state.closedChallenges = [];
    },
    getClosedChallengesSuccess: (state, { payload }) => {
      state.closedChallenges = payload;
      state.getClosedChallengesLoading = false;
      state.getClosedChallengesError = null;
      state.getClosedChallengesSuccess = true;
    },
    getClosedChallengesError: (state, { payload }) => {
      state.getClosedChallengesLoading = false;
      state.getClosedChallengesError = payload;
      state.getClosedChallengesSuccess = false;
    },

    //empty
    emptyChartData: (state) => {
      state.challenges = [];
      state.getChallengesLoading = false;
      state.getChallengesError = null;
      state.getChallengesSuccess = false;
    },

    getPositionsRequest: (state) => {
      state.getPositionsLoading = true;
      state.getPositionsError = null;
      state.getPositionsSuccess = false;
      state.positions = [];
    },
    getPositionsSuccess: (state, { payload }) => {
      state.positions = payload;
      state.getPositionsLoading = false;
      state.getPositionsError = null;
      state.getPositionsSuccess = true;
    },
    getPositionsError: (state, { payload }) => {
      state.getPositionsLoading = false;
      state.getPositionsError = payload;
      state.getPositionsSuccess = false;
    },

    getChallengeInfoRequest: (state) => {
      state.getChallengeInfoLoading = true;
      state.getChallengeInfoError = null;
      state.getChallengeInfoSuccess = false;
      state.challengeInfo = null;
    },
    getChallengeInfoSuccess: (state, { payload }) => {
      state.challengeInfo = payload;
      state.getChallengeInfoLoading = false;
      state.getChallengeInfoError = null;
      state.getChallengeInfoSuccess = true;
    },
    getChallengeInfoError: (state, { payload }) => {
      state.getChallengeInfoLoading = false;
      state.getChallengeInfoError = payload;
      state.getChallengeInfoSuccess = false;
    },
  },
});
export const ChallengeMainActions = ChallengeMainSlice.actions;

export default ChallengeMainSlice.reducer;
